import { render, staticRenderFns } from "./DictionariesClassList.vue?vue&type=template&id=8582c838&scoped=true&"
import script from "./DictionariesClassList.vue?vue&type=script&lang=js&"
export * from "./DictionariesClassList.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesClassList.vue?vue&type=style&index=0&id=8582c838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8582c838",
  null
  
)

export default component.exports